import api from './Api';

const BASE_URL = 'wallet/';

export default {
    // Get wallet balance (current endpoint)
    getWalletBalance: () => {
        return api.get(`${BASE_URL}balance`);
    },
    getUserWallet: (userId) => {
        return api.get(`${BASE_URL}${userId}/balance`);
    },
    // Get transactions for a specific wallet
    getWalletTransactions: (walletId) => {
        return api.get(`${BASE_URL}${walletId}/transactions`);
    },
    addTransaction: (walletId, amount, description) => {
        return api.post(`${BASE_URL}${walletId}/transaction`, {
            amount,
            description
        });
    },
    addWithdrawalRequest: (userId) => {
        return api.post(`${BASE_URL}users/${userId}/withdrawal-request`);
    },
    // Returns [{ month: 'YYYY-MM', label: 'May 2026', amount: N }, ...]
    // for the months whose payouts are still sitting in the wallet.
    getPendingPayoutMonths: (userId) => {
        return api.get(`${BASE_URL}users/${userId}/pending-payout-months`);
    },
    requestWithdrawalWithInvoices: (userId, files) => {
        const list = Array.isArray(files) ? files.filter(Boolean) : [];
        if (list.length === 0) {
            return Promise.reject(new Error('At least one invoice file is required'));
        }
        return Promise.all(list.map((file) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve({ invoice: reader.result, fileName: file.name });
            reader.onerror = reject;
            reader.readAsDataURL(file);
        }))).then((invoices) =>
            api.post(`${BASE_URL}users/${userId}/withdrawal-request-invoice`, { invoices })
        );
    },
    getAllWithdrawals: () => {
        return api.get(`${BASE_URL}withdrawals`);
    }
}; 